module.exports = __webpack_public_path__ + "img/tachograph-digital.21961a38.svg";